import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle-button"
      aria-label="Toggle theme"
      style={{
        position: 'fixed',
        bottom: '32px',
        right: '32px',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        background: 'var(--gold-primary)',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 20px rgba(184, 134, 11, 0.4)',
        transition: 'all 0.3s ease',
        zIndex: 1000
      }}
    >
      {theme === 'dark' ? (
        <Sun size={24} color="#000000" />
      ) : (
        <Moon size={24} color="#000000" />
      )}
      
      <style jsx="true">{`
        .theme-toggle-button:hover {
          transform: scale(1.1) rotate(15deg);
          box-shadow: 0 6px 30px rgba(184, 134, 11, 0.6);
        }

        .theme-toggle-button:active {
          transform: scale(0.95);
        }

        @media (max-width: 640px) {
          .theme-toggle-button {
            bottom: 20px !important;
            right: 20px !important;
            width: 48px !important;
            height: 48px !important;
          }
        }
      `}</style>
    </button>
  );
};

export default ThemeToggle;
